<template>
  <v-row no-gutters class="mt-12">
    <v-col cols="1" md="1" xs="12" sm="12"></v-col>
    <v-col cols="12" md="10" xs="12" sm="12">
      <div class="cardTable mt-8">
  <v-row no-gutters class="">
      <v-col cols="12"
        md="10"
        xs="12"
        sm="12">
        <v-tabs background-color="transparent" v-model="tabs">
    <v-tab key="1">{{$t("table.reportrooms") }}</v-tab>
  </v-tabs>
      </v-col>
      <v-col cols="12"
        md="2"
        xs="12"
        sm="12"
        class="mt-2">
        <v-btn block
        @click="backhome"
        style="font-family: Sarabun;
        font-size: 16px;
        font-weight: 500;"
        depressed
        color="primary">
        {{$t("button.btnback") }}
        </v-btn>
      </v-col>
    </v-row>
  <v-card
  class="mx-auto"
  max-width="100%"
  outlined
>
  <v-tabs-items v-model="tabs">
    <v-row class="pl-8 mt-2">
      <v-col cols="12"
        md="12"
        xs="12"
        sm="12">
        <v-icon  color="#0355CB">mdi-account-group</v-icon>
       <span> {{$t("table.Allmeeting") }} {{ datahistory.report.length }} {{$t("table.list") }} </span>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-simple-table>
    <template v-slot:default>
    <thead >
    <tr>
      <th class="text-center">
        {{$t("table.No") }}
      </th>
      <th class="text-center">
        {{$t("loginpage.name") }}
      </th>
      <th class="text-center">
        {{$t("message.day") }} - {{$t("table.timeinout") }}
      </th>
      <th class="text-center">
        {{$t("table.Numberattendance") }}
      </th>
      <th class="text-center">
        {{$t("table.manage") }}
      </th>
    </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, key) in datahistory.report"
        :key="key"
      >
        <td class="text-center">{{ key+1 }}</td>
        <td class="text-center">{{ datahistory.room_name }}</td>
        <td class="text-center">
          <!-- เริ่ม : {{ setdatestartend(item.start_time)}} , {{settimestartend(item.start_time)}} - สิ้นสุด : {{ setdatestartend(item.end_time)}} , {{settimestartend(item.end_time)}} -->
          {{ item.s_date}} {{item.s_time}} - {{ item.e_date}} {{item.e_time}}
        </td>
        <td class="text-center">
          {{ item.forhost_mem.length}}
        </td>
        <td class="text-center">
          <v-icon @click="openreport(item.forhost_mem, datahistory, item)" class="pr-2" color="#0355CB">mdi-clipboard-text-search-outline</v-icon>
          <v-icon :disabled="dialog"
            :loading="dialog" 
            @click="downloadReport(key)"
            color="#0355CB">mdi-tray-arrow-down</v-icon>
            <!-- @click="dialog = true" -->
          <span style="color: #0355CB;">
            {{datahistory.meeting_id.substring(0,8)}}
            {{$t("table.downloadrecord") }}.pdf
          </span>
        </td>
        </tr>
      </tbody>
      <v-dialog
    v-model="dialog"
    :scrim="false"
    persistent
    width="50%">
    <v-card
      color=""
    >
      <v-card-text>
        {{$t("loginpage.Pleasestandby") }} 
        <span style="font-size: 40px;"> . . . . </span>
        <v-progress-linear
            v-model="percentCompleted"
            height="25"
          >
            <strong>{{ percentCompleted }}%</strong>
          </v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
     </template>
    </v-simple-table>
  </v-tabs-items>
  </v-card>
<v-card
  class="mx-auto"
  max-width="100%"
  max-height="100%"
  outlined>
  <v-row>
    <v-col>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
    </v-col>
    <Dialogreporthistory/>
  </v-row>
</v-card>
</div>
</v-col>
</v-row>
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/0.9.0rc1/jspdf.min.js"></script>
<script>
import Dialogreporthistory from '../report/dialogreporthistory.vue'
import { mapState, mapActions } from "vuex";
import jsPDF from "jspdf";

export default {
components: {
  Dialogreporthistory
},
data() {
  return {
    tabs: null,
    datahis: '',
    element:'',
    dialog: false,
    interval: {},
    value: 0,
    percentCompleted:0,
    jwt: require("jsonwebtoken"),
  };
},
beforeDestroy () {
    clearInterval(this.interval)
  },
watch: {
  // dialog() {
  //   this.interval = setInterval(() => {
  //     console.log(this.value)
  //       if (this.value === 100) {
  //         this.dialog = false
  //         clearInterval(this.interval)
  //         return (this.value = 0)
  //       }
  //       this.value += 10
  //     }, 700)
  //   },
},
computed: {
  ...mapState("dialog", ['datahistory']),
   localDialogreport: {
      get() {
        return this.datahistory
      }
    },
},
mounted() {
  this.datahis = this.datahistory
  // console.log('datahis', this.datahis)
  if (this.datahis === '') {
    this.$router.push('/')
  } else {
  }
},
created() {
  if (localStorage.getItem('user-token') === null) {
    this.$router.push('/')
  } else {
    this.decodejwttoken()
  }
},
methods: {
  ...mapActions("dialog", ['setdialogreporthistory', 'setdatadialogreporthistory', 'setdatadialogparticipants_pexip',
'setdatadialogparticipants_pexipend']),
  backhome(){
    this.$router.push('/manage?' + 'tabs=' + 1).catch(() => {});
  },
  openreport(data, item, keytime) {
    this.setdialogreporthistory(true)
    this.setdatadialogreporthistory(data)
    this.setdatadialogparticipants_pexip(item)
    this.setdatadialogparticipants_pexipend(keytime)
    console.log('setdatadialogreporthistory', data)
    console.log('keytime', keytime)
    console.log('setdatadialogparticipants_pexip', item)
  },
  async downloadReport(key) {
    this.dialog = true
    // console.log('key', key)
    // console.log('meeting_id', this.datahis.meeting_id)
    // this.setDialogdownloadding(true)
    this.downloadProgress = true;
    try {
      this.axios
        .get(
          `${process.env.VUE_APP_API}/api/lv1/report/download/report/${this.datahis.meeting_id}/${key}`,
          {
            responseType: "arraybuffer",
            onDownloadProgress: progressEvent => {
              this.percentCompleted = Math.floor(progressEvent.loaded / progressEvent.total * 100)
              if(this.percentCompleted === 100) {
               this.percentCompleted = 0
              }
            },
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = this.datahis.meeting_id + ".pdf";
          link.click();
          this.downloadProgress = false;
          this.dialog = false
          // clearInterval(this.interval)
        });
    } catch (error) {
      this.dialog = false
      // clearInterval(this.interval)
      if (e.response.status === 401) {
        this.swal.fire({
            title: this.$t("message.Sessiontimeout"),
            text: '',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false
          }).then(result => {
            if (result.value) {
              localStorage.clear()
              localStorage.setItem("lang", "th")
              window.open('/', '_self')
            }
          })
      } else {
        this.dialog = false
        // clearInterval(this.interval)
        if (e.response.data.message !== undefined) {
          this.$swal(e.response.data.message, '', 'warning')
        } else {
          console.log(">>>>> START ERROR /api/rooms/downloadreport/ <<<<<")
          if (error.response !== undefined) {
            console.log(error.response)
          } else {
            console.log(error)
          }
          console.log(">>>>> END ERROR /api/rooms/downloadreport/ <<<<<")
        }
      }
    }
  },
  // async downloadReport(key) {
  //   console.log('item', this.datahis)
  //   try {
  //     const res = await this.axios
  //       .get(
  //         `${process.env.VUE_APP_API}/api/v1/history/download/report/${this.datahis.meeting_id}/${key}`,
  //         {
  //           responseType: 'arraybuffer',
  //           onDownloadProgress: (progressEvent) => {
  //             this.percentCompleted = Math.floor(
  //               (progressEvent.loaded / progressEvent.total) * 100
  //             )
  //           }
  //         })
  //     const blob = new Blob([res.data], { type: 'application/pdf' })
  //     const link = document.createElement('a')
  //     link.href = window.URL.createObjectURL(blob)
  //     link.download = meetingid + '.pdf'
  //     link.click()
  //     this.percentCompleted = 0
  //   } catch (error) {
  //     this.percentCompleted = 0
  //     console.log('errordownload', error)
  //   }
  //   // console.log('item', item)
  // },
  decodejwttoken() {
    var token = localStorage.getItem('user-token')
    const decryptedText = this.CryptoJS.AES.decrypt(
      token,
      process.env.VUE_APP_SECRET_KEY
    )
      .toString(this.CryptoJS.enc.Utf8)
      .replace(/"/g, '')
    var data = this.jwt.decode(decryptedText)
  },
  // openreport(data) {
  // },
  setdatestartend(dateInput) {
  // console.log('date', date);
  const date = new Date(`${dateInput}Z`)
  const year = date.getFullYear()
  let month = date.getMonth()+1
  let dt = date.getDate()
  const hh = date.getHours()
  const mm = date.getMinutes()

  if (dt < 10) {
  dt = '0' + dt
  }
  if (month < 10) {
  month = '0' + month
  }
  return `${dt}/${month}/${year}`
  // return `${hh}:${mm}`
},
  blackreport(){
    this.$router.push('/')
  },
 settimestartend(dateInput) {
  // console.log('date', date);
  const date = new Date(`${dateInput}Z`)
  const year = date.getFullYear()
  let month = date.getMonth()+1
  let dt = date.getDate()
  let ss = date.getUTCSeconds()
  let hh = date.getHours()
  let mm = date.getMinutes()
  mm = mm < 10 ? `0${mm}` : mm
  ss = ss < 10 ? `0${ss}` : ss
  hh = hh < 10 ? `0${hh}` : hh

  if (dt < 10) {
  dt = '0' + dt
  }
  if (month < 10) {
  month = '0' + month
  }
    return `${hh}:${mm}:${ss}`
  // if (hh < 1) {
  //   return `${'0' + hh}:${mm}:${ss}`
  // } else {
  //   return `${hh}:${mm}:${ss}`
  // }
  // return `${dt}/${month}/${year}`
  // return `${hh}:${mm}`
//  return `${hh}:${mm}`
},
},
};
</script>

<style scoped>
div.hidden {
border-style: hidden;
width: 1100px;
}
</style>
